if (!customElements.get('rone-countdown-timer')) {
  customElements.define(
    'rone-countdown-timer',
    class RoneCountdownTimer extends HTMLElement {
      connectedCallback() {
        this.hoursEl = this.querySelector('[data-hours]');
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');
        this.tick = this.tick.bind(this);
        this.tick();
        this.interval = setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      pad(value) {
        return String(value).padStart(2, '0');
      }

      tick() {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        const remaining = Math.max(0, end - now);

        this.hoursEl.textContent = this.pad(Math.floor(remaining / 3.6e6));
        this.minutesEl.textContent = this.pad(Math.floor((remaining % 3.6e6) / 6e4));
        this.secondsEl.textContent = this.pad(Math.floor((remaining % 6e4) / 1e3));
      }
    }
  );
}
